import { adminApi } from "../../../api/adminClient";
import { cloneFormData, unwrapList, unwrapOne } from "../utils/adminApiHelpers";

export { unwrapList, unwrapOne };

export function buildProductFormData(data) {
  const fd = new FormData();
  fd.append("name_ar", String(data.name_ar ?? "").trim());
  fd.append("name_en", String(data.name_en ?? "").trim());
  fd.append("category_id", String(data.category_id ?? "").trim());
  fd.append("description_ar", String(data.description_ar ?? "").trim());
  fd.append("description_en", String(data.description_en ?? "").trim());
  fd.append(
    "is_featured",
    data.is_featured === true || data.is_featured === "1" || data.is_featured === 1
      ? "1"
      : "0"
  );

  const imgList = data.image;
  const img =
    imgList && typeof imgList.length === "number" && imgList.length > 0
      ? imgList[0]
      : null;
  if (img instanceof File && img.size > 0) {
    fd.append("image", img);
  }

  const g = data.gallery;
  if (g && typeof g.length === "number") {
    for (let i = 0; i < g.length; i += 1) {
      const f = g[i];
      if (f instanceof File && f.size > 0) {
        fd.append("gallery[]", f);
      }
    }
  }

  return fd;
}

export function buildProductFormDataForUpdate(data) {
  const fd = buildProductFormData(data);
  fd.append("name[ar]", String(data.name_ar ?? "").trim());
  fd.append("name[en]", String(data.name_en ?? "").trim());
  fd.append("description[ar]", String(data.description_ar ?? "").trim());
  fd.append("description[en]", String(data.description_en ?? "").trim());
  return fd;
}

export const fetchProductList = () => adminApi.get("/products");

export const fetchProductById = (id) => adminApi.get(`/admin/products/${id}`);

/** Categories for product form — adjust path if your API differs */
export const fetchCategoriesList = () => adminApi.get("/categories");

export const createProduct = (formData) =>
  adminApi.post("/admin/products", formData);

export const updateProduct = (id, formData) => {
  const fd = cloneFormData(formData);
  fd.append("_method", "PUT");
  return adminApi.post(`/admin/products/${id}`, fd);
};

export const deleteProduct = (id) => adminApi.delete(`/admin/products/${id}`);
